// @ts-strict-ignore
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useApolloClient, gql, useMutation } from "@apollo/client";

import clearApolloStore from "app/utils/clearApolloStore";

import { RemoveRefreshTokenCookieLogoutMutation, RemoveRefreshTokenCookieLogoutMutationVariables } from "app/GraphqlGeneratedTypes/types";

import Avatar from "app/components/concept/Avatar/Avatar";
import PageContainer from "app/pages/AppDashboard/components/PageContainer/PageContainer";
import TextSign from "app/components/TextSign/TextSign";

import classes from "./style.scss";

const REMOVE_REFRESH_TOKEN_COOKIE_GQL = gql`
	mutation removeRefreshTokenCookieLogout {
		removeRefreshTokenCookie
	}
`;

const AppHeader = ({
	activeUser,
	history,
	onBurgerClick,
	isBurgerActive
}) => {
	const apolloHookClient = useApolloClient();

	const [removeRefreshTokenCookieMutation] = useMutation<
	RemoveRefreshTokenCookieLogoutMutation, RemoveRefreshTokenCookieLogoutMutationVariables
	>(REMOVE_REFRESH_TOKEN_COOKIE_GQL);

	const onLogOutClick = async (e) => {
		e.preventDefault();

		await removeRefreshTokenCookieMutation();
		
		clearApolloStore(apolloHookClient);

		history.block(true);

		localStorage.removeItem("dcbyte-jwt");
		
		history.replace("/");
	};

	return (
		<div className={classes.headerContainer}>
			<PageContainer className={classes.headerPageContainer}>
				<Link to={activeUser ? "/dashboard" : "/login"} className={classes.logo}>
					<img
						className={classes.logoImage}
						src="/assets/images/branding/dcbyte-logo-new-colored.svg"
						alt="dcbyte-logo"
						role="img"
						aria-label="logo"
						width="141.63px"
						height="42px"
					/>
				</Link>

				<div className={`${classes.headerItemContainer} ${classes.profileContainer}`}>
					<Avatar user={activeUser} />

					<div className={classes.headerItemDropdown}>
						<div className={classes.headerItemDropdownContent}>
							{activeUser
								? (
									<p className={classes.profileGreeting}>{`Hello ${activeUser.firstName}`}</p>
								)
								: null
							}

							<div>
								{activeUser
									? (
										<Fragment>
											<Link
												className={classes.profileButton}
												to="/settings"
											>
												Settings
											</Link>

											<Link
												className={classes.profileButton}
												to="/"
												onClick={onLogOutClick}
											>
												Log Out
											</Link>
										</Fragment>
									)
									: (
										<Link
											className={classes.profileButton}
											to="/login"
										>
											Log In
										</Link>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<div
					className={`${classes.hamburger} ${classes.hamburgerSpin} ${isBurgerActive ? classes.isActive : null}`}
					onClick={onBurgerClick}
				>
					<span className={classes.hamburgerBox}>
						<span className={classes.hamburgerInner}>

						</span>
					</span>
				</div>
			</PageContainer>
		</div>
	);
};

AppHeader.propTypes = {
	activeUser: PropTypes.object,
	history: PropTypes.object,
	onBurgerClick: PropTypes.func,
	isBurgerActive: PropTypes.bool,
	disableMaxWidth: PropTypes.bool
};

export default AppHeader;
